<script>
export default {
  emits: ['onAction'],
  props: {
    rowData: Object,
    actions: {
      type: Array,
      validator: (value) => {
        const fields = ['key', 'label', 'icon']
        return fields.every((field) => value.every((action) => action[field]))
      }
    },
    showOneAction: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleAction (actionKey) {
      const action = this.actions.find(a => a.key === actionKey)
      if (action?.action && typeof action.action === 'function') {
        action.action(this.rowData)
      }
      this.$emit('onAction', {
        action: actionKey,
        rowData: this.rowData
      })
    }
  }
}
</script>

<template>
  <el-button
    v-if="actions.length === 1 && showOneAction"
    class="sedap-actions-menu"
    type="text"
    @click="handleAction(actions[0].key)"
    :title="actions[0].label"
  >
    <i :class="(actions[0].iconPrefix || 'fa') + ` fa-${actions[0].icon}`"></i>
  </el-button>
  <el-dropdown v-else trigger="click" @command="handleAction">
    <el-button class="sedap-actions-menu" type="text">
      <font-awesome-icon icon="ellipsis-v" class="sedap-actions-menu__icon"/>
    </el-button>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item
        v-for="action in actions"
        :key="action.key"
        :command="action.key"
        class="sedap-actions-menu__option"
        >
        <i :class="(action.iconPrefix || 'fa') + ` fa-${action.icon}`"></i>
        {{ action.label }}
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<style lang="scss">
@import './styles.scss';
</style>



// WEBPACK FOOTER //
// src/components(new)/UI/Tables/ActionsMenu/ActionsMenu.vue